exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkbox-group {\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.checkbox-group > input[type='checkbox'] {\n    margin-right: 8px;\n}\n\n:host /deep/ label {\n    cursor: pointer;\n    font-weight: 400;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-checkbox-control/happy-checkbox-control.component.css
// module id = 827
// module chunks = 0